export const locale = {
    lang: 'tr',
    data: {
      'EDITOR': {
        'ACERCADE': 'İsteğe bağlı olarak, anketi oluşturmadan önce anketin bazı özelliklerini düzenleyebilirsiniz, yapılan değişiklikler ankete eriştiğinizde anketin içinde görüntülenebilir.',
        'CONCAMBIOS': 'Anket yapılandırmasındaki değişiklikler tespit edildi, önce yapılan değişikliklerin uygulanması için anket oluşturmalısınız, daha sonra adımı tamamlayabilirsiniz.',
        'CARGANDO': 'Bilgi yükleniyor',
        'GUARDANDO': 'Değişiklikleri kaydediyor',
        'CONFIGADICIONAL': {
          'TITULO': 'Ek yapılandırma',
          'SUBTITULO': 'Bu ayarlar tüm diller için anket için geçerlidir',
          'DISPONIBLES': 'Kullanılabilir kontroller',
          'SAVEOK': 'Yapılandırma başarıyla güncellendi',
          'CONTROLES': {
            'PIN': 'Kullanıcı PIN kodu ile anket korumasını etkinleştirin',
            'RANDOM': 'Rastgele doğrulama sorusunu etkinleştirin',
            'LIDERES': 'Liderlerin (CEO / Patron) isimlerini açıklamaların bakış açısıyla göster'
          }
        },
        'ELEMENTOS': {
          'GUIA': 'Bu bloğun elemanları',
          'COLORES': {
            'ORIGINAL': 'Değiştirilmemiş öğe',
            'MODIFICADO': 'Değiştirilmiş öğe'
          },
          'TOOLTIPS': {
            'ORIGINAL': 'Hiçbir öğe değiştirilmedi',
            'MODIFICADO': 'Bir veya daha fazla öğe değiştirildi',
            'COMPLETO': 'Tüm öğeler değiştirildi'
          },
          'ETIQUETAS': {
            'IMAGEN': {
              'NOHAY': 'Resim yok',
              'ACTUAL': 'Geçerli resim'
            },
            'TEXTO': {
              'INGRESAR': 'Metninizi girin'
            }
          },
          'BOTONES': {
            'ENTRAR': 'Anket özelliklerini düzenleyin',
            'REGRESAR': 'Geri gitmek',
            'CONTINUAR': 'Devam et',
            'CANCELAR': 'İptal etmek',
            'GUARDAR': 'Değişiklikleri Kaydet',
            'IMAGEN': 'Resmi değiştir',
            'EDITOR': 'Mesajı düzenleyin',
            'ELEMENTOS': 'Yardım Edin',
            'ACTIVAR': 'Göstermek',
            'DESACTIVAR': 'Saklamak',
            'ACEPTAR': 'Kabul etmek',
          }
        },
        'PANTALLAS': {
          'LOGIN': {
            'TITULO': 'Oturum aç',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Broker logosu',
                'ELEMENTOS': {
                  'logo': 'Komisyoncunun logosunu değiştirmek için bir resim yükleyebilirsiniz.'
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Önceki talimatlar',
                'ELEMENTOS': {
                  'text': 'Ankete girmeden önce gösterilecek talimatları yazabilirsiniz.'
                }
              },
              'LOGINFORM': {
                'TITULO': 'Giriş Formu',
                'ELEMENTOS': {
                  'inputPlaceHolderPass': '"Şifre" alanı için ipucu metnini değiştirebilirsiniz',
                  'buttons_login_label': 'Giriş düğmesinin metnini değiştirebilirsiniz',
                  'recoveryAccessKey_text': 'Şifreyi kurtarmak için düğme metnini değiştirebilirsiniz',
                }
              },
              'BACKGROUND': {
                'TITULO': 'Arka plan görüntüsü',
                'ELEMENTOS': {
                  'backgroudImage': 'Bu ekranda görünen arka plan resmini değiştirebilirsiniz',
                }
              },
            }
          },
          'GENERICOS': {
            'TITULO': 'Genel öğeler',
            'PASOS': {
              'LOGO': {
                'TITULO': 'Broker logosu',
                'ELEMENTOS': {
                  'logo': 'Komisyoncunun logosunu değiştirmek için bir resim yükleyebilirsiniz.'
                }
              },
              'HEADER': {
                'TITULO': 'Başlık öğeleri',
                'ELEMENTOS': {
                  'buttons_logout_label': 'Giriş düğmesinin metnini değiştirebilirsiniz',
                  'header_logo': 'Sistem logosunun görüntüsünü değiştirebilirsiniz',
                  'isShowLastLogin_active': 'Son erişimin tarihini göstermeyi veya gizlemeyi seçebilirsiniz.',
                  'backgroundImage': 'Bu ekranda görünen arka plan resmini değiştirebilirsiniz',
                  'header_showUserName': 'Kullanıcı adını göstermeyi veya gizlemeyi seçebilirsiniz'
                }
              },
            }
          },
          'BIENVENIDA': {
            'TITULO': 'Karşılama ekranı',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Ekran içeriği',
                'ELEMENTOS': {
                  'text': 'Karşılama ekranının içeriğini değiştirebilirsiniz',
                  'buttons_next_label': 'Devam etmek için düğme metnini değiştirebilirsiniz',
                }
              },
              'LOGOUT': {
                'TITULO': 'Çıkış yaparken mesaj',
                'ELEMENTOS': {
                  'title': 'Mesajın başlığını değiştirebilirsiniz',
                  'text': 'Mesajın metnini değiştirebilirsiniz',
                  'buttons_cancel_label': 'Eylemi iptal etmek için düğme metnini değiştirebilirsiniz',
                  'buttons_logout_label': 'Oturumu kapatmak için düğmenin metnini değiştirebilirsiniz',
                }
              },
            }
          },
          'INSTRUCCIONES': {
            'TITULO': 'Talimat ekranı',
            'PASOS': {
              'CONTENIDO': {
                'TITULO': 'Ekran içeriği',
                'ELEMENTOS': {
                  'text': 'Talimat ekranının içeriğini değiştirebilirsiniz',
                  'buttons_previous_label': 'Geri dönmek için düğme metnini değiştirebilirsiniz',
                  'buttons_start_label': 'Başlamak için düğme metnini değiştirebilirsiniz',
                  'buttons_continue_label': 'Devam etmek için düğme metnini değiştirebilirsiniz',
                }
              },
              'LOGOUT': {
                'TITULO': 'Çıkış yaparken mesaj',
                'ELEMENTOS': {
                  'title': 'Mesajın başlığını değiştirebilirsiniz',
                  'text': 'Mesajın metnini değiştirebilirsiniz',
                  'buttons_cancel_label': 'Eylemi iptal etmek için düğme metnini değiştirebilirsiniz',
                  'buttons_logout_label': 'Oturumu kapatmak için düğmenin metnini değiştirebilirsiniz',
                }
              },
            }
          },
          'TERMINOS': {
            'TITULO': 'Anket kabul mesajı',
            'PASOS': {
              'ACTIVAR': {
                'TITULO': 'Anketi kabul etmek veya reddetmek için mesajı etkinleştirin',
                'ELEMENTOS': {
                  'active': 'Başlangıç öncesi mesajını etkinleştir'
                }
              },
              'CONTENIDO': {
                'TITULO': 'Mesaj içeriği',
                'ELEMENTOS': {
                  'header_title': 'Mesajın başlığını değiştirebilirsiniz',
                  'text': 'Mesajın içeriğini değiştirebilirsiniz',
                  'buttons_previous_label': 'Geri dönmek için düğme metnini değiştirebilirsiniz',
                  'buttons_acept_label': 'Anketi reddetmek için düğme metnini değiştirebilirsiniz',
                  'buttons_cancel_label': 'Anketi kabul etmek için düğme metnini değiştirebilirsiniz'
                }
              },
              'LOGOUT': {
                'TITULO': 'Çıkış yaparken mesaj',
                'ELEMENTOS': {
                  'title': 'Mesajın başlığını değiştirebilirsiniz',
                  'text': 'Mesajın metnini değiştirebilirsiniz',
                  'buttons_cancel_label': 'Eylemi iptal etmek için düğme metnini değiştirebilirsiniz',
                  'buttons_logout_label': 'Oturumu kapatmak için düğmenin metnini değiştirebilirsiniz',
                }
              },
              'NOACEPT': {
                'TITULO': 'Anketi reddederken mesaj',
                'ELEMENTOS': {
                  'title': 'Mesajın başlığını değiştirebilirsiniz',
                  'text': 'Mesajın metnini değiştirebilirsiniz',
                  'buttons_saveAndExit_label': 'Onaylamak ve çıkmak için düğme metnini değiştirebilirsiniz',
                }
              },
            }
          },
          'SURVEY': {
            'TITULO': 'Anket ekranı',
            'PASOS': {
              'NAV': {
                'TITULO': 'Yön tuşları',
                'ELEMENTOS': {
                  'buttons_next_label': 'Devam etmek için düğme metnini değiştirebilirsiniz',
                  'buttons_previous_label': 'Geri dönmek için düğme metnini değiştirebilirsiniz',
                  'buttons_finish_label': 'Anketi sonlandırmak için düğme metnini değiştirebilirsiniz',
                }
              },
              'INSTRUCCIONES': {
                'TITULO': 'Talimat yan paneli',
                'ELEMENTOS': {
                  'button_label': 'Komut panelini görüntülemek için düğme metnini değiştirebilirsiniz.',
                  'active': 'Komut panelinde düğmeyi göstermeyi veya gizlemeyi seçebilirsiniz',
                  'text': 'Talimat ekranının içeriğini değiştirebilirsiniz',
                }
              },
              'SOPORTE': {
                'TITULO': 'Destek ipuçlarının yan paneli',
                'ELEMENTOS': {
                  'button_label': 'Destek ipuçları panelini görüntülemek için düğme metnini değiştirebilirsiniz',
                  'active': 'Destek ipuçları paneli düğmesini göstermeyi veya gizlemeyi seçebilirsiniz',
                  'text': 'Destek ipuçları ekranının içeriğini değiştirebilirsiniz',
                }
              },
              'COLUMNA1': {
                'TITULO': 'İfadeler: Perspektif 1',
                'ELEMENTOS': {
                  'title': 'Perspektif 1\'in sütun başlığını değiştirebilirsiniz',
                  'tooltip_active': 'Sütun başlığı ipucunu göstermeyi veya gizlemeyi seçebilirsiniz',
                  'tooltip_text': 'Sütun başlığı araç ipucunun içeriğini değiştirebilirsiniz',
                }
              },
              'COLUMNA2': {
                'TITULO': 'İfadeler: Perspektif 2',
                'ELEMENTOS': {
                  'title': 'Perspektif 2\'nin sütun başlığını değiştirebilirsiniz',
                  'tooltip_active': 'Sütun başlığı ipucunu göstermeyi veya gizlemeyi seçebilirsiniz',
                  'tooltip_text': 'Sütun başlığı araç ipucunun içeriğini değiştirebilirsiniz',
                }
              },
              'FINISH_1': {
                'TITULO': 'Anketin sonundaki mesaj',
                'ELEMENTOS': {
                  'title': 'Mesajın başlığını değiştirebilirsiniz',
                  'textAnswered': 'Tüm soruları cevaplarken görüntülenen mesajın metnini değiştirebilirsiniz.',
                  'textNotAnswered': 'Tüm soruları cevaplamayarak görüntülenen mesajın metnini değiştirebilirsiniz.',
                  'textFooter': 'Mesajın metnini değiştirebilirsiniz',
                  'buttons_previous_label': 'Geri dönmek için düğme metnini değiştirebilirsiniz',
                  'buttons_close_label': 'Anketi sonlandırmak için düğme metnini değiştirebilirsiniz',
                }
              },
              'FINISH_2': {
                'TITULO': 'Anketi tamamladıktan sonra mesaj',
                'ELEMENTOS': {
                  'windowFinishMessage_title': 'Mesajın başlığını değiştirebilirsiniz',
                  'windowFinishMessage_text': 'Mesajın metnini değiştirebilirsiniz',
                  'windowRanking_active': 'Anketi derecelendirmek için mesajı göstermeyi veya gizlemeyi seçebilirsiniz',
                  'windowRanking_text': 'Anketi derecelendirmek için mesajın metnini değiştirebilirsiniz.',
                  'windowFinishMessage_buttons_close_label': 'Devam etmek için düğme metnini değiştirebilirsiniz',
                }
              },
              'LOGOUT_1': {
                'TITULO': 'Çıkış yaparken mesaj',
                'ELEMENTOS': {
                  'title': 'Mesajın başlığını değiştirebilirsiniz',
                  'text': 'Mesajın metnini değiştirebilirsiniz',
                  'textBandRequired': 'Geri çevrilemezlik uyarı mesajının metnini değiştirebilirsiniz.',
                  'buttons_previous_label': 'Eylemi iptal etmek için düğme metnini değiştirebilirsiniz',
                  'buttons_saveAndExit_label': 'Değişiklikleri kaydetmek ve oturumu kapatmak için düğme metnini değiştirebilirsiniz',
                }
              },
              'LOGOUT_2': {
                'TITULO': 'Çıkış yaptıktan sonra mesaj',
                'ELEMENTOS': {
                  'title': 'Mesajın başlığını değiştirebilirsiniz',
                  'text': 'Mesajın metnini değiştirebilirsiniz',
                  'buttons_close_label': 'Devam etmek için düğme metnini değiştirebilirsiniz',
                }
              },
            }
          },
        }
      }
    }
};
